import * as IBAN from 'iban'

/**
 * Validate for a valid IBAN
 */
export const isValidIBAN = (value?: string): string | void => (value && !IBAN.isValid(value) ? 'global.not_a_valid_iban' : undefined)
